// extracted by mini-css-extract-plugin
export default {"title":"InfoTitle_title__AfIo5"};